import apiService from './ApiService';
import { debugError } from '../utils/debugUtils';

class TimeService {
  constructor() {
    this._offsetMs = 0;
    this._syncPromise = null;
  }

  /**
   * Sincroniza el offset entre el reloj del dispositivo y el del servidor.
   * Compensa la latencia de red asumiendo ida/vuelta simétrica.
   */
  async sync() {
    if (this._syncPromise) return this._syncPromise;
    this._syncPromise = this._doSync();
    return this._syncPromise;
  }

  async _doSync() {
    try {
      const t0 = Date.now();
      const { serverTimeMs } = await apiService.get('/api/v1/game/server-time', false);
      const t1 = Date.now();
      const estimatedServerTimeAtT1 = serverTimeMs + (t1 - t0) / 2;
      this._offsetMs = estimatedServerTimeAtT1 - t1;
    } catch (err) {
      debugError('[TimeService] No se pudo sincronizar con la hora del servidor, usando reloj local:', err);
      this._offsetMs = 0;
    }
  }

  /** Equivalente a Date.now() pero corregido con la hora del servidor. */
  getServerNow() {
    return Date.now() + this._offsetMs;
  }
}

export default new TimeService();
